/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import ValidateAddressModal from '@brands/Dashboard/MyProfile/Patient/Sections/ValidateAddressModal/ValidateAddressModal';
import { stateOptions } from '@brands/Utils/selectOptions';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { ValidationModalInterface } from '@brands/Utils/validateAddress';
import cn from 'classnames';
import React from 'react';
import { FieldErrors, UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import styles from './styles.module.scss';

interface AddressSectionProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<UnifiedProfileSubmit>;
  getValues: UseFormGetValues<any>;
  setTextValue: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  setValue: UseFormSetValue<any>;
  showValidationAddressModal: ValidationModalInterface;
  required: boolean;
  disabled?: boolean;
}

const AddressSection: React.FC<AddressSectionProps> = ({
  register,
  errors,
  getValues,
  setTextValue,
  setValue,
  required,
  showValidationAddressModal,
  disabled = false,
}): JSX.Element => {
  return (
    <>
      <div className={styles.sameRow}>
        <div className={cn(styles.rowItem, styles.rowItemHalf)}>
          <TextField
            {...register('address1')}
            label="Address"
            required={required}
            errors={errors}
            name="address1"
            disabled={disabled}
            value={getValues('address1')}
            onChange={(e) => setTextValue(e, 'address1')}
            wrapperClassName={`fs-exclude ${styles.inputWrapper}`}
            inputClass={styles.input}
          />
        </div>
        <div className={cn(styles.rowItem, styles.rowItemHalf)}>
          <TextField
            {...register('address2')}
            label="Apartment, suite, etc."
            errors={errors}
            name="address2"
            disabled={disabled}
            value={getValues('address2')}
            onChange={(e) => setTextValue(e, 'address2')}
            wrapperClassName={`fs-exclude ${styles.inputWrapper}`}
            inputClass={styles.input}
          />
        </div>
      </div>
      <div className={cn(styles.sameRow)}>
        <div className={cn(styles.rowItem, styles.rowItemThird)}>
          <TextField
            {...register('city')}
            label="City"
            required={required}
            errors={errors}
            name="city"
            disabled={disabled}
            value={getValues('city')}
            onChange={(e) => setTextValue(e, 'city')}
            wrapperClassName={`fs-exclude ${styles.inputWrapper}`}
            inputClass={styles.input}
          />
        </div>
        <div className={cn(styles.rowItem, styles.rowItemThird)}>
          <MUISelectInput
            {...register('state')}
            name="state"
            label="State"
            required={required}
            disabled={disabled}
            options={stateOptions}
            wrapperClassName={`fs-mask ${styles.inputWrapper}`}
            errors={errors}
            value={getValues('state') || ''}
            onChange={(value: string) => {
              if (value) {
                setValue('state', value, { shouldValidate: true });
              }
            }}
          />
        </div>
        <div className={cn(styles.rowItem, styles.rowItemThird)}>
          <TextField
            {...register('zip_code')}
            label="Zip code"
            required={required}
            errors={errors}
            name="zip_code"
            disabled={disabled}
            value={getValues('zip_code')}
            onChange={(e) => setTextValue(e, 'zip_code')}
            wrapperClassName={`fs-exclude ${styles.inputWrapper}`}
            inputClass={styles.input}
          />
        </div>
      </div>
      <ValidateAddressModal
        title={showValidationAddressModal.title}
        isOpen={showValidationAddressModal.isOpen}
        recommended={showValidationAddressModal.recommended}
        recommendedAddress={showValidationAddressModal.recommendedAddress}
        whatYouEntered={showValidationAddressModal.whatYouEntered}
        onClose={showValidationAddressModal.onClose}
        onKeepCurrentAddress={showValidationAddressModal.onKeepCurrentAddress}
        onConfirmChange={showValidationAddressModal.onConfirmChange}
      />
    </>
  );
};

export default AddressSection;
